import moment from 'moment';
import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, Modal, ModalBody, ModalHeader, Progress, Tooltip } from 'reactstrap';
import language from '../../../assets/languages/language';
import Loader from '../../../common/loader';
import FD from '../../RestAPI/fetchData';
import AppRoutes from '../../config/AppRoutes';
import App_data from '../../config/App_data';
import { Y_AXIS_SCALES } from '../../../common/constant';
import { messages } from '../../../common/messages';
import { renderHTMLContent, renderSanitizedHTML } from '../../../common/function';
import EmailResubscribe from '../../../components/EmailResubscribe';

/* eslint-disable*/

var i = '';
class Cfa3Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      reportAnswerStatus: false,
      reportEditStatus: false,
      reportEditId: '',
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      items_val: '',
      item_status: '',
      dropdownOpen: false,
      ValidToken: false,
      token: '',
      idname: '',
      flashreport: [], //All Flash question Store
      savedquestion: [],
      reportquestion: [],
      progress_bar_zero: [],
      activeTabFlashcards: '1',
      activeTabSaved: '1',
      activeTabReports: '1',
      notesProgressBar: [],
      progress_bar_slider: [],
      main_bargraph_data: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      bar_chapter: '',
      bar_level_main: [
        'Ethics',
        'Quants',
        'Econ',
        'FRA',
        'Corpo',
        'Portfolio',
        'Equity',
        'Fixed Income',
        'Derivatives',
        'Al',
      ],
      bar_main_user: [],
      bar_main_class: [],
      startDate: '',
      startDate_second: '',
      send_startDate: '',
      send_startDate_second: '',
      more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      show_outer: 'hide_block',
      chapters: '',
      ErrorMessage: '',
      subreadings_status: false,
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
      display_main_loader: 'show_block',
      qpLoader: true,
      savedLoader: true,
      flashLoader: true,
      reportLoader: true,
      tooltips: [
        {
          placement: `${language.LC().SEPARATE_YOUR_RESULT}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().YOU_CAN_SEE}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().THAT_SPECIFIC_NOTES}`,
          text_align: 'left',
        },
      ],
      notesFlashReport: [],
      videoFlashReport: [],
      savednotes: [],
      savedvideo: [],
      reportnotes: [],
      reportsvideo: [],
      reportquestionCBT: [],
      notesProgressLoader: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
    this.toggleDone = this.toggleDone.bind(this);
    this.toggleCloseReport = this.toggleCloseReport.bind(this);
    this.toggleAlertReport = this.toggleAlertReport.bind(this);
    this.CloseEditQuesReport = this.CloseEditQuesReport.bind(this);
    this.OpenEditQuesReport = this.OpenEditQuesReport.bind(this);
    this.onContactChange = this.onContactChange.bind(this);
    this.CloseEditVideoReport = this.CloseEditVideoReport.bind(this);
    this.OpenEditNotesReport = this.OpenEditNotesReport.bind(this);
    this.CloseEditNotesReport = this.CloseEditNotesReport.bind(this);
    this.OpenEditVideoReport = this.OpenEditVideoReport.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      items_val: '',
      item_status: '',
    });
  }

  toggleAlertReport(item, type, e) {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: item.id,
      type: type,
    });
  }
  deleteFlashCard = async (type, id) => {
    const { idname: id_name, token } = this.state;
    const payload = {
      id_name,
      token,
      type: type,
      question_type: '',
      exam: 'cfa3',
      level: '',
      item_id: id,
    };
    await FD.callAPI(`${App_data.backend_api}/question_bank_2024/deleteFlashCard`, payload);
  };
  toggleCloseReport() {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      contactStatus: false,
      ErrorMessage: '',
    });
  }
  toggleDone = async () => {
    const { idname, token, items_val, item_status } = this.state;
    const { question_id, item_id, video_id } = items_val;
    if (this.state.item_status == 'flashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(
        async resp => {
          if (resp.success) {
            await this.getQuestionFlashcards();
          } else {
            console.log('error');
          }
        },
      );
    }
    if (item_status == 'savedquestion') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('question', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/cfa_3question_bank/deleteSavequestion', data).then(
        async resp => {
          if (resp.success) {
            await this.getQuestionSaved();
          } else {
            console.log('error');
          }
        },
      );
    }

    if (this.state.item_status == 'Reportsquestion') {
      var data = {
        token,
        idname,
        reports: items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa_3question_bank/deleteDashboardQuestionReports',
        data,
      ).then(async resp => {
        if (resp.success) {
          await this.getQuestionReports();
        } else {
          console.log('error');
        }
      });
    }

    // ==================== NOTES AND VIDEOS : ==========================//

    if (item_status == 'savednotes') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('notes', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/cfa3_notes/deleteSaveNotes', data).then(
        async resp => {
          if (resp.success) {
            await this.getNotesSaved();
          } else {
          }
        },
      );
    }

    if (item_status == 'savedvideos') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('video', video_id ? video_id : item_id);
      await FD.callAPI(App_data.backend_api + '/cfa3_videos/deleteSaveVideo', data).then(
        async resp => {
          if (resp.success) {
            await this.getVideosSaved();
          } else {
          }
        },
      );
    }

    if (this.state.item_status == 'Notesflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(App_data.backend_api + '/cfa3_notes/deleteDashboardFlashCard', data).then(
        async resp => {
          if (resp.success) {
            await this.getNotesFlashcards();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (this.state.item_status == 'Videoflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa3_videos/deleteDashboardVideoFlashCard',
        data,
      ).then(async resp => {
        if (resp.success) {
          await this.getVideoFlashcards();
        } else {
          //console.log('error');
        }
      });
    }

    if (this.state.item_status == 'Reportsnotes') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      FD.callAPI(App_data.backend_api + '/cfa3_notes/deleteDashboardNotesReports', data).then(
        async resp => {
          if (resp.success) {
            await this.getNotesReports();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (this.state.item_status == 'Reportsvideos') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa3_videos/deleteDashboardVideoReports',
        data,
      ).then(async resp => {
        if (resp.success) {
          await this.getVideoReports();
        } else {
          //console.log('error');
        }
      });
    }

    if (this.state.item_status == 'CBTreportsquestion') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/deleteReport', data).then(
        async resp => {
          if (resp.success) {
            await this.getCBTQestionReports();
          } else {
            //console.log('error');
          }
        },
      );
    }
    // ==================== NOTES AND VIDEOS ;==========================//
    this.setState({
      alert_status: false,
    });
  };

  handleCBTQuestionReportSubmit = async event => {
    event.preventDefault();
    if (this.state.cbtquesReport === '' && this.state.cbtquesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, cbtquesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: cbtquesReport,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateReport', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            cbtquesReport: '',
          });
          await this.getCBTQestionReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  handleChange(date) {
    this.setState({
      startDate: date,
      startDate_second: '',
      send_startDate: moment(date).format('YYYY-MM-DD'),
      subreadings_status: false,
    });
  }
  handleChange_second(date) {
    if (this.state.startDate != '') {
      // document.getElementById('outer_readings_id').innerHTML = '';
      this.setState(
        {
          startDate_second: date,
          send_startDate_second: moment(date).format('YYYY-MM-DD'),
          subreadings_status: true,
          display_main_loader: 'show_block',
        },
        function afterdateChange() {
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            startDate: this.state.send_startDate,
            endDate: this.state.send_startDate_second,
          };
          // Get Notes Progress By User
          FD.callAPI(App_data.backend_api + '/cfa_3dashboard/getNotesProgressForUser', data).then(
            resp => {
              if (resp.success) {
                this.setState({ notesProgressBar: resp.notesProgressBarData });
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/cfa_3dashboard/mainProgressbar', data).then(resp => {
            if (resp.success) {
              var dataString = JSON.stringify(resp.chapters);
              var dataReason = JSON.parse(dataString);

              var final_array_main = [];

              for (i = 0; i < dataReason.length; i++) {
                var right_answered = dataReason[i].answered_count;
                var total_question = dataReason[i].attempted_count;

                var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);
                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }
              this.setState({
                bar_main_user: final_array_main,
                display_main_loader: 'hide_block',
              });
            } else {
              this.setState({ display_main_loader: 'hide_block' });
            }
          });
          FD.callAPI(App_data.backend_api + '/cfa_3dashboard/mainProgressclassbar', data).then(
            resp => {
              if (resp.success) {
                var dataString = JSON.stringify(resp.chaptersclass);
                var dataReason = JSON.parse(dataString);
                var final_array_main = [];
                for (i = 0; i < dataReason.length; i++) {
                  var right_answered = dataReason[i].answered_count;
                  var total_question = dataReason[i].attempted_count;
                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );
                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ bar_main_class: final_array_main });
              } else {
                console.log(resp.success + '------------failure');
              }
            },
          );
          // FD.callAPI(App_data.backend_api+'/cfa_3dashboard/getProgressChapter',data).then(resp => {
          //   if(resp.success)
          //   {
          //     this.setState({bar_chapter:resp.chapters});
          //     this.setState({progress_bar_zero:resp.chapters});
          //   }
          //   else
          //   {
          //     console.log(resp.success+'------------failure');
          //   }
          // });
          FD.callAPI(App_data.backend_api + '/cfa_3dashboard/getQuestionProgByUser', data).then(
            resp => {
              // console.log(resp.progressbarzero_data)
              if (resp.success) {
                this.setState({
                  bar_chapter: resp.progressBarData,
                  progress_bar_zero: resp.progressBarData,
                  qpLoader: false,
                });
              } else {
                console.log(resp.success + '------------failure');
              }
            },
          );
        },
      );
    }
  }

  _deleteFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('flashcard');
  };

  _deleteSavequestion = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savedquestion');
  };

  _deleteReportsquestino = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsquestion');
  };

  _getall = () => {
    if (this.state.show_outer == 'hide_block') {
      this.setState({
        show_outer: 'show_block',
        more_detail_button: `${language.LC().Hide_details}`,
      });
    }
    if (this.state.show_outer == 'show_block') {
      this.setState({
        show_outer: 'hide_block',
        more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      });
    }
  };

  async componentDidMount() {
    window.scroll(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };

    FD.callAPI(App_data.backend_api + '/user/authtoken', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getChapters', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, chapters: resp.chapters });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/cfa_3dashboard/mainProgressbar', data).then(resp => {
      if (resp.success) {
        this.setState({ display_main_loader: 'hide_block' });
        var dataString = JSON.stringify(resp.chapters);
        var dataReason = JSON.parse(dataString);
        var final_array_main = [];
        for (i = 0; i < dataReason.length; i++) {
          var right_answered = dataReason[i].answered_count;
          var total_question = dataReason[i].attempted_count;
          var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);
          final_array_main.push(user_graph_val);
        }
        this.setState({ bar_main_user: final_array_main });
      } else {
        console.log(resp.success + '------------failure');
      }
    });
    this.setState({ display_main_loader: 'show_block' });

    FD.callAPI(App_data.backend_api + '/cfa_3dashboard/mainProgressclassbar', data).then(resp => {
      if (resp.success) {
        var dataString = JSON.stringify(resp.chaptersclass);
        var dataReason = JSON.parse(dataString);

        var final_array_main = [];

        for (i = 0; i < dataReason.length; i++) {
          var right_answered = dataReason[i].answered_count;
          var total_question = dataReason[i].attempted_count;
          var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);
          final_array_main.push(user_graph_val);
        }
        this.setState({ bar_main_class: final_array_main });
      } else {
        console.log(resp.success + '------------failure');
      }
    });

    FD.callAPI(App_data.backend_api + '/cfa_3dashboard/getQuestionProgByUser', data).then(resp => {
      if (resp.success) {
        this.setState({
          progress_bar_zero: resp.progressBarData,
          bar_chapter: resp.progressBarData,
          qpLoader: false,
        });
      } else {
        console.log(resp.success + '------------failure');
      }
    });

    await this.getQuestionFlashcards();

    await this.getQuestionSaved();

    await this.getQuestionReports();
    // ================== NOTES AND VIDEOS : ===================== //
    await this.getNotesFlashcards();
    await this.getNotesSaved();
    await this.getNotesReports();
    await this.getVideoFlashcards();
    await this.getVideosSaved();
    await this.getVideoReports();
    this.getCBTQestionReports();

    await FD.callAPI(App_data.backend_api + '/cfa_3dashboard/getNotesProgressForUser', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            notesProgressBar: resp.notesProgressBarData,
            notesProgressLoader: false,
          });
        }
      },
    );
    // ================== NOTES AND VIDEOS ; ===================== //
  }

  // function for get  question report
  getQuestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_3question_bank/getReportsQuestionsbyuserid',
      data,
    ).then(async resp => {
      if (resp.success) {
        this.setState({ reportquestion: resp.questions, reportLoader: false });
      } else {
        console.log(resp.success + '------------failure');
      }
    });
  };

  getCBTQestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getreportedQuestion', data).then(
      async resp => {
        //console.log('heeeeeeeeeeeeeeeeeeeeeeeeeeeee', resp);
        if (resp.success) {
          this.setState({
            reportquestionCBT: resp.questions,
            reportLoader: false,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  question report
  getQuestionFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFlashcardsbyuserid', data).then(
      resp => {
        if (resp.success) {
          this.setState({ flashreport: resp.flash_report, flashLoader: false });
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  question report
  getQuestionSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_3question_bank/getFavQuestionsbyuserid',
      data,
    ).then(resp => {
      if (resp.success) {
        this.setState({ savedquestion: resp.questions, savedLoader: false });
      } else {
        console.log(resp.success + '------------failure');
      }
    });
  };

  _beginChapter = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    const { isEssayQuestion, essayQuestionIndex, question_id } = item;
    if (!isEssayQuestion) {
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getQuestionsbyid', data).then(resp => {
        if (resp.success) {
          var dataparam = {
            token: this.state.token,
            idname: this.state.idname,
            chapter_id: resp.questionsbyid.chapter_id,
          };
          FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCases', dataparam).then(
            resp_case => {
              if (resp_case.success) {
                const caseOffset = resp_case.readings.findIndex(
                  item => item.id === resp.questionsbyid.case_id,
                );
                this.context.router.push({
                  pathname: `/cfa3/chapter/${resp.questionsbyid.chapter_id}/${resp.questionsbyid.case_id
                    }/${parseInt(caseOffset)}/${resp.questionsbyid.question_number}`,
                  state: {
                    token: this.state.token,
                    idname: this.state.idname,
                    reading: resp.questionsbyid.reading_id,
                    chapter: resp.questionsbyid.chapter_id,
                  },
                });
              } else {
                console.log('Some Thing Went Wrong');
              }
            },
          );
        } else {
          console.log('Not Found');
        }
      });
    } else {
      const { token, idname } = this.state;
      const data = {
        token,
        idname,
        isEssayQuestion: 1,
        essayQuestionIndex,
        questionId: question_id,
      };
      FD.callAPI(App_data.backend_api + '/cfa3EssayQuestions/getQuestionDetails', data).then(
        res => {
          if (res.success) {
            const {
              questionId,
              essayQuestionIndex,
              caseId,
              casesIndex,
              chapterId,
              chapterName,
            } = res;
            //:caseId/:chapterID/:chapterName/:questionIndex/:caseIndex
            this.context.router.push({
              pathname: AppRoutes.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', caseId)
                .replace(':chapterID', chapterId)
                .replace(':chapterName', chapterName)
                .replace(':questionIndex', essayQuestionIndex)
                .replace(':caseIndex', casesIndex),
            });
          }
        },
      );
    }
  };

  questionProgressBarFun() {
    return this.state.progress_bar_zero.map((item, index) => {
      var progressnotes_zero = Math.round((item.counttotquestion / item.question_stat_count) * 100);
      if (progressnotes_zero < 1) {
        progressnotes_zero = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>Q.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes_zero}
                      style={{ width: Math.min(progressnotes_zero, 100) + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  OpenEditQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      quesReport: item.comment,
    });
  }

  CloseEditQuesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      quesReport: '',
      ErrorMessage: '',
    });
  }

  // question form submit function
  async handleQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.quesReport === '' && this.state.quesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, quesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: quesReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_3question_bank/UpdateReportsQuestionsbyuserid',
      data,
    ).then(async resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          quesReport: '',
        });
        await this.getQuestionReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  // function for state change of edit report form fileds
  InputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      ErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  SubjectInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      SubjectErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  CommentInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      CommentErrorMessage: '',
    });
  }

  onContactChange = (data, index) => {
    if (!this.state.contactStatus) {
      this.setState({
        contactID: data.id,

        contactIndex: index,
        contactStatus: true,
      });
    } else {
      this.setState({
        contactID: '',
        contactType: '',
        contactIndex: '',
        contactSubject: '',
        contactComment: '',
        SubjectErrorMessage: '',
        CommentErrorMessage: '',
        contactStatus: false,
      });
    }
  };

  onContactSubmit = async event => {
    event.preventDefault();
    if (this.state.contactSubject === '' && this.state.contactSubject.length < 1) {
      this.setState({
        displaytext: 'show_block',
        SubjectErrorMessage: "Subject can't be empty",
        isLoading: false,
      });
      return;
    }
    if (this.state.contactComment === '' && this.state.contactComment.length < 1) {
      this.setState({
        displaytext: 'show_block',
        CommentErrorMessage: "Comment can't be empty",
        isLoading: false,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    const { idname, token, contactComment, contactSubject } = this.state;
    const data = {
      idname: idname,
      token: token,
      contactComment: contactComment,
      contactSubject: contactSubject,
    };
    await FD.callAPI(App_data.backend_api + '/contact_us/sendReportHelpRequest', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            isLoading: false,
            successAlert: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = e => {
    this.setState({
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
    });
  };

  flashcardTabToggle = tab => {
    if (this.state.activeTabFlashcards !== tab) {
      this.setState({
        activeTabFlashcards: tab,
      });
    }
  };

  savedTabToggle = tab => {
    if (this.state.activeTabSaved !== tab) {
      this.setState({
        activeTabSaved: tab,
      });
    }
  };

  reportsTabToggle = tab => {
    if (this.state.activeTabReports !== tab) {
      this.setState({
        activeTabReports: tab,
      });
    }
  };

  OpenEditCBTQuesReport = (item, e) => {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      cbtquesReport: item.comment,
      type: 'cbtquesReport',
    });
  };

  view = item => {
    if (item.mockData) {
      let mock = JSON.parse(item.mockData, item);
      const redirectToFinishTest =
        mock.type === messages.PATHWAY
          ? AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS_FINISH
          : AppRoutes.CFA3_CBT_QUESTIONS_FINISH;
      this.context.router.push({
        pathname: redirectToFinishTest
          .replace(':id', mock.mock_id)
          .replace(':caseno', mock.caseId)
          .replace(':questiono', item.question_id)
          .replace(':testid', mock.test_id)
          .replace(':caseOffset', mock.caseOffset)
          .replace(':quesOffset', mock.quesOffset)
          .replace(':timer', mock.timer),
      });
    }
  };

  CloseEditCBTQuesReport = () => {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      cbtquesReport: '',
      type: '',
      ErrorMessage: '',
    });
  };

  _deleteCBTReportsquestino = items => {
    this.setState({ items_val: items });
    this.toggleAlert('CBTreportsquestion');
  };
  render() {
    const {
      activeTabFlashcards,
      activeTabSaved,
      activeTabReports,
      qpLoader,
      savedLoader,
      flashLoader,
      reportLoader,
    } = this.state;
    let flashreport_val = this.state.flashreport;
    let reportquestionCBT_val = this.state.reportquestionCBT;
    let progress_bar_zero_val = this.state.progress_bar_zero;

    let flashcard_data = '';
    let savedquestion_data = '';
    let question_reportsData = ''; // for question reports
    let progress_bar_data = '';

    let notes_flashcard_data = '';
    let video_flashcard_data = '';

    let savednotes_data = '';
    let savedvideo_data = '';

    let notes_reportsData = ''; // for notes report
    let video_reportsData = ''; // for video report
    let cbt_reportsData = ''; // for cbt question reports

    let notes_flashreport_val = this.state.notesFlashReport;
    let video_flashreport_val = this.state.videoFlashReport;
    let savedvideo_val = this.state.savedvideo;

    let reportnotes_val = this.state.reportnotes;
    let reportvideo_val = this.state.reportsvideo;
    /*first main graph*/
    let main_bar_val = this.state.bar_chapter;
    let main_bar_percentage = this.state.bar_main_user;
    let main_bar_user_percentage = this.state.bar_main_class;
    let main_bar_data = [];
    var i = 0;

    Object.keys(main_bar_val).map(function (key) {
      var dataString = JSON.stringify(main_bar_val[key]);
      var dataReason = JSON.parse(dataString);
      main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
      var chapter_id = dataReason.chapter_id;
      i++;
    });

    var bar_data = {
      labels: main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: main_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_bar_user_percentage,
        },
      ],
    };

    const role = localStorage.getItem('role');
    let chapters = this.state.chapters;
    let reading_data = '';

    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'flash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, "span")}

          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
            <button className="btn btn-primary" onClick={this._deleteFlashcard.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (flashLoader) {
      flashcard_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.savedquestion.length) {
      savedquestion_data = this.state.savedquestion.map((items, index) => (
        <div id={'savedque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavequestion.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, "span")}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, "span")}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
            <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (savedLoader) {
      savedquestion_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      savedquestion_data = <div className='text-center'>{language.LC().NO_SAVED_QUESTIONS}</div>;
    }

    if (this.state.reportquestion.length) {
      question_reportsData = this.state.reportquestion.map((items, index) => (
        <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditQuesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={this.state.reportEditStatus && this.state.reportEditId === items.id}
              toggle={this.OpenEditQuesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <Button className='close' color='secondary' onClick={this.CloseEditQuesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleQuestionReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='quesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.quesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().REPORT}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditQuesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items)}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={this.state.reportAnswerStatus && this.state.reportAnswerId === items.id}
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={() => this.onContactChange(items, index)}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={() => this.onContactChange(items, index)}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>
                        {renderSanitizedHTML(items.answer)}
                      </span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsquestino.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(
              items.isEssayQuestion
                ? items.essay_topic_name && items.essay_topic_name.includes('$$')
                  ? items.essay_topic_name
                  : items.essay_topic_name.length > 150
                    ? `${items.essay_topic_name.substring(0, 150)}...`
                    : items.essay_topic_name
                : items.topic_name,
              'span',
              'text-inline-dashboard'
            )}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>
              {renderSanitizedHTML(items.comment)}
            </span>
          </p>
        </div>
      ));
    } else if (reportLoader) {
      question_reportsData = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      question_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    // ================= Notes And Videos : ====================//

    if (this.state.notesFlashReport.length) {
      // console.log(
      //   'I am inside notesFlashReport -----> ',
      //   this.state.notesFlashReport
      // );
      notes_flashcard_data = notes_flashreport_val.map((items, index) => (
        <div id={'notesFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteNotesFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, "span")}
          </p>
        </div>
      ));
    } else {
      notes_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.videoFlashReport.length) {
      // console.log(
      //   'I am inside videoFlashReport -----> ',
      //   this.state.videoFlashReport
      // );
      video_flashcard_data = video_flashreport_val.map((items, index) => (
        <div id={'videoFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this.redirectToList(items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteVideoFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, "span")}
          </p>
        </div>
      ));
    } else {
      video_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.savednotes.length) {
      savednotes_data = this.state.savednotes.map((items, index) => (
        <div id={'savednotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSaveNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items['cfa3_note.name'], "span")}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, "span")}
              </div>
            )}
          </p>
        </div>
      ));
    } else {
      savednotes_data = <div className='text-center'> {language.LC().NO_SAVED_NOTES} </div>;
    }

    // console.log('I am outside savedvideo -----> ', this.state.savedvideo);
    if (this.state.savedvideo.length) {
      savedvideo_data = savedvideo_val.map((items, index) => (
        <div id={'savedvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this.redirectToList(items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSaveVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, "span")}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, "span")}
              </div>
            )}
          </p>
        </div>
      ));
    } else {
      savedvideo_data = <div className='text-center'> {language.LC().NO_SAVED_VIDEO} </div>;
    }

    if (this.state.reportnotes.length) {
      // console.log('I am inside reportnotes -----> ', this.state.reportnotes);

      notes_reportsData = reportnotes_val.map((items, index) => (
        <div id={'reportsnotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            {' '}
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditNotesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.OpenEditNotesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id}{' '}
                {renderHTMLContent(items['cfa3_note.name'], 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditNotesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleNotesReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='notesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.notesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditNotesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            {items.isSend && items.reply ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'notesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id}{' '}
                {renderHTMLContent(items['cfa3_note.name'], 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                    this.state.contactType === 'notesReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={() => this.onContactChange(items, index, 'notesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={() => this.onContactChange(items, index, 'notesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{
                      paddingLeft: '0.5rem',
                      paddingTop: '0.5rem',
                    }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                  this.state.contactType === 'notesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>
                        {renderSanitizedHTML(items.reply)}
                      </span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items['cfa3_note.name'], 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>
              {renderSanitizedHTML(items.comment)}
            </span>
          </p>
        </div>
      ));
    } else {
      notes_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportsvideo.length) {
      // console.log('I am inside reportsvideo -----> ', this.state.reportsvideo);

      video_reportsData = reportvideo_val.map((items, index) => (
        <div
          id={'reportsvideos_' + items['cfa3_video_reports.id']}
          key={index}
          className='flash_card_box'
        >
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items['cfa3_video_reports.id']}
            </span>

            <span
              className={`float-right status-${items['cfa3_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'
                }`}
            >
              <strong className='text-capitalize'>
                {items['cfa3_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>
          <div className='mt-1'>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items['cfa3_video_reports.video_id']}
            </span>
            {!items['cfa3_video_reports.isSend'] &&
              !items['cfa3_video_reports.reply'] &&
              items['cfa3_video_reports.status'] !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={() =>
                  items['cfa3_video_reports.isSend']
                    ? null
                    : this.OpenEditVideoReport({
                      ...items,
                      id: items['cfa3_video_reports.id'],
                    })
                }
                disabled={items['cfa3_video_reports.isSend']}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items['cfa3_video_reports.id'] &&
                this.state.type === 'videoReport'
              }
              toggle={this.OpenEditVideoReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items['cfa3_video_reports.video_id']}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <Button className='close' color='secondary' onClick={this.CloseEditVideoReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleVideoReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='videoReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.videoReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditVideoReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this.redirectToList(items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items['cfa3_video_reports.reply'] ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(
                    this,
                    { ...items, id: items['cfa3_video_reports.id'] },
                    'videoReport',
                  )}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items['cfa3_video_reports.id'] &&
                this.state.type === 'videoReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                {/* V. {items.video_id}{' '} */}
                V. {items['cfa3_video_reports.video_id']}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                    this.state.type === 'videoReport' &&
                    this.state.contactID === items['cfa3_video_reports.id'] &&
                    this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={() =>
                        this.onContactChange(
                          { ...items, id: items['cfa3_video_reports.id'] },
                          index,
                          'videoReport',
                        )
                      }
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={() =>
                        this.onContactChange(
                          { ...items, id: items['cfa3_video_reports.id'] },
                          index,
                          'videoReport',
                        )
                      }
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{
                      paddingLeft: '0.5rem',
                      paddingTop: '0.5rem',
                    }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                  this.state.type === 'videoReport' &&
                  this.state.contactID === items['cfa3_video_reports.id'] &&
                  this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>
                        {renderSanitizedHTML(items['cfa3_video_reports.reply'])}
                      </span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, "span")}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>
              {renderSanitizedHTML(items['cfa3_video_reports.comment'])}
            </span>
          </p>
        </div>
      ));
    } else {
      video_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportquestionCBT.length) {
      cbt_reportsData = reportquestionCBT_val.map((items, index) => {
        let parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
        let mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
        return (
          <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
            <div>
              <span>
                <strong> {language.LC().TICKET_ID}: </strong> {items.id}
              </span>

              <span
                className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                  }`}
              >
                <strong className='text-capitalize'>
                  {items.status === 'resolved' ? 'resolved' : 'pending'}
                </strong>
              </span>
            </div>

            <div className='mt-1'>
              <span>
                <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
              </span>
              {!items.isSend && !items.answer && items.status !== 'resolved' ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                  onClick={items.isSend ? null : this.OpenEditCBTQuesReport.bind(this, items)}
                  disabled={items.isSend}
                >
                  <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                  <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                    {' '}
                  </i>
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportEditStatus &&
                  this.state.reportEditId === items.id &&
                  this.state.type === 'cbtquesReport'
                }
                toggle={this.OpenEditCBTQuesReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id}
                  {renderHTMLContent(mockName, "span")}
                  <Button className='close' color='secondary' onClick={this.CloseEditCBTQuesReport}>
                    ×
                  </Button>
                </ModalHeader>
                <ModalBody>
                  <div className='card-block'>
                    <form onSubmit={this.handleCBTQuestionReportSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <textarea
                            id='comment'
                            name='cbtquesReport'
                            rows='6'
                            className='form-control'
                            placeholder='Content..'
                            onChange={this.InputChange.bind(this)}
                            value={this.state.cbtquesReport}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.ErrorMessage}
                          </span>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-12 d-flex'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {language.LC().UPDATE}
                          </button>

                          <button
                            type='button'
                            className='btn btn-danger active pointer_class margin_left_10'
                            onClick={this.CloseEditCBTQuesReport}
                          >
                            {' '}
                            {language.LC().CANCEL}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </ModalBody>
              </Modal>

              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW} </div>
                <i
                  onClick={() => this.view(items)}
                  className={this.state.viewCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>

              {items.isSend && items.reply && items.reply.length > 0 ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                  <i
                    onClick={this.toggleAlertReport.bind(this, items, 'cbtquesReport')}
                    className={this.state.viewREPORTCSS}
                    style={{ color: '#1f8ceb' }}
                  />
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportAnswerStatus &&
                  this.state.reportAnswerId === items.id &&
                  this.state.type === 'cbtquesReport'
                }
                toggle={this.toggleAlertReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id}{' '}
                  {renderHTMLContent(items.topic_name, "span")}
                  <div className='contact-us-btn float-right'>
                    {this.state.contactStatus &&
                      this.state.contactType === 'cbtquesReport' &&
                      this.state.contactID === items.id &&
                      this.state.contactIndex === index ? (
                      <Button
                        className='btn btn-primary'
                        onClick={() => this.onContactChange(items, index, 'cbtquesReport')}
                      >
                        {language.LC().GO_TO_ANSWER}{' '}
                      </Button>
                    ) : (
                      <Button
                        className='btn btn-primary'
                        onClick={() => this.onContactChange(items, index, 'cbtquesReport')}
                      >
                        {' '}
                        <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                        {language.LC().I_need_further_help}{' '}
                      </Button>
                    )}
                    <Button
                      className='close'
                      style={{
                        paddingLeft: '0.5rem',
                        paddingTop: '0.5rem',
                      }}
                      color='secondary'
                      onClick={this.toggleCloseReport}
                    >
                      ×
                    </Button>
                  </div>
                </ModalHeader>
                <ModalBody>
                  {this.state.contactStatus &&
                    this.state.contactType === 'cbtquesReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                    !this.state.successAlert ? (
                      <form onSubmit={this.onContactSubmit.bind(this)}>
                        <div className='row'>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().SUBJECT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactSubject'
                              name='contactSubject'
                              rows='2'
                              className='form-control'
                              placeholder='Subject..'
                              onChange={this.SubjectInputChange.bind(this)}
                              value={this.state.contactSubject}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.SubjectErrorMessage}
                            </span>
                          </div>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().COMMENT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactComment'
                              name='contactComment'
                              rows='6'
                              className='form-control'
                              placeholder='Comment..'
                              onChange={this.CommentInputChange.bind(this)}
                              value={this.state.contactComment}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.CommentErrorMessage}
                            </span>
                          </div>
                          <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                            <button type='submit' className='btn btn-primary active pointer_class'>
                              {' '}
                              {this.state.isLoading
                                ? 'Please wait ...'
                                : language.LC().SEND_REQUEST}
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className='text-center'>
                      <p className='margin_bottom_20'>
                        <span>
                          {renderSanitizedHTML(items.reply)}
                        </span>
                      </p>
                    </div>
                  )}
                </ModalBody>
              </Modal>
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().DELETE} </div>
                <i
                  onClick={this._deleteCBTReportsquestino.bind(this, items)}
                  className={this.state.deleteCSS}
                  style={{ color: '#f51a00' }}
                >
                  {' '}
                </i>
              </span>
            </div>
            <p className='mt-1'>
              <strong> {language.LC().REPORT}: </strong>
              <span>
                {renderSanitizedHTML(items.comment)}
              </span>
            </p>
          </div>
        );
      });
    } else {
      cbt_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    // ================= Notes And Videos ; ====================//

    // alert((this.state.tooltips)[0].placement);
    const { notesProgressLoader } = this.state;
    return (
      <div>
        <div className='animated fadeIn'>
          <EmailResubscribe />
          <div className='row'>
            <div className='col-sm-12 col-md-12 margin_bottom_20'>
              <h1 className='section_head'>{language.LC().CFA_LEVEL_III_MY_DASHBOARD}</h1>
            </div>
            <div className='col-lg-8'>
              <div className='card margin_bottom_20'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-1 text-md-right align-self-center'>
                      <label className='margin_bottom_0'>{language.LC().FROM}</label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleChange}
                          placeholderText='Select date'
                          width='100%'
                        />
                      </div>
                    </div>
                    <div className='col-sm-1 text-md-center align-self-center'>
                      <label className='margin_bottom_0'> {language.LC().TO}</label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          placeholderText='Select date'
                          width='100%'
                          selected={this.state.startDate_second}
                          minDate={this.state.startDate}
                          onChange={this.handleChange_second.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().PERFORMANCE}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>
                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ----------------------- Flashcard ------------- */}

              {/* <div className='padding_bottom_30'>
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_FLASHCARDS}
                </h1>

                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.flashcardTabToggle('1');
                      }}
                      className={activeTabFlashcards === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.flashcardTabToggle('2');
                      }}
                      className={activeTabFlashcards === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    <li
                      onClick={() => {
                        this.flashcardTabToggle('3');
                      }}
                      className={activeTabFlashcards === '3' ? 'active' : ''}
                    >
                      <span> {language.LC().VIDEOS} </span>
                    </li>
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabFlashcards === '1'
                        ? flashcard_data
                        : this.state.activeTabFlashcards === '2'
                        ? notes_flashcard_data
                        : video_flashcard_data}
                    </div>
                  </div>
                </div>
              </div> */}
              {/* ----------------------- Saved  ------------- */}

              <div className='padding_bottom_30'>
                {' '}
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
                </h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.savedTabToggle('1');
                      }}
                      className={activeTabSaved === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>

                    <li
                      onClick={() => {
                        this.savedTabToggle('2');
                      }}
                      className={activeTabSaved === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    <li
                      onClick={() => {
                        this.savedTabToggle('3');
                      }}
                      className={activeTabSaved === '3' ? 'active' : ''}
                    >
                      <span> {language.LC().VIDEOS} </span>
                    </li>
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSaved === '1'
                        ? savedquestion_data
                        : this.state.activeTabSaved === '2'
                          ? savednotes_data
                          : savedvideo_data}
                    </div>
                  </div>
                </div>
              </div>
              {/* ----------------------- Reports ------------- */}

              <div>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_REPORTS}</h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('1');
                      }}
                      className={activeTabReports === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>

                    <li
                      onClick={() => {
                        this.reportsTabToggle('2');
                      }}
                      className={activeTabReports === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('4');
                      }}
                      className={activeTabReports === '4' ? 'active' : ''}
                    >
                      <span> Mocks </span>
                    </li>

                    <li
                      onClick={() => {
                        this.reportsTabToggle('3');
                      }}
                      className={activeTabReports === '3' ? 'active' : ''}
                    >
                      <span> {language.LC().VIDEOS} </span>
                    </li>
                  </ul>
                </div>

                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabReports === '1'
                        ? question_reportsData
                        : this.state.activeTabReports === '2'
                          ? notes_reportsData
                          : this.state.activeTabReports === '3'
                            ? video_reportsData
                            : cbt_reportsData}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUESTION_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='1'
                      id='1'
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  {/* {console.log('qpLoader', qpLoader)} */}
                  <table className='table table-hover mb-0 compress_table'>
                    {qpLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.questionProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* ------------ Notes Progress Start ------------------------ */}
              {
                <div className='card'>
                  <div className='card-header'>
                    {language.LC().NOTES_PROGRESS}
                    <div className='card-actions card_action_tooltip float-right'>
                      <TooltipItem
                        key='2'
                        id='2'
                        content={this.state.tooltips[2].placement}
                        place_tip={this.state.tooltips[2].text_align}
                      />
                    </div>
                  </div>
                  <div className=''>
                    <table className='table table-hover mb-0 compress_table'>
                      {notesProgressLoader ? (
                        <div className='card-block-loader'>
                          <Loader />
                        </div>
                      ) : (
                        <tbody>{this.renderNotesProgressBar()}</tbody>
                      )}
                    </table>
                  </div>
                </div>
              }
              {/* ------------------- Notes Progress End ------------------- */}
            </div>
          </div>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlert}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <button type='button' className='close' aria-label='Close' onClick={this.toggleClose}>
                <span aria-hidden='true'>×</span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.toggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
            {/*<ModalFooter>
                        <Button className="btn btn-sm btn-secondary" color="secondary" onClick={this.toggleClose}>Cancel</Button>
                    </ModalFooter>*/}
          </Modal>
        </div>
      </div>
    );
  }

  // ========================== NOTES AND VIDEOS Function ======================= //

  renderNotesProgressBar = () => {
    const { notesProgressBar } = this.state;
    return notesProgressBar.map((item, index) => {
      const { notesCount, attemptedNotes } = item;
      const progressNotesData = Math.max(Math.round((attemptedNotes / notesCount) * 100), 1);
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>N.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressNotesData}
                      style={{ width: `${progressNotesData}%` }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };
  toggleCloseReport() {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      ErrorMessage: '',
      contactStatus: false,
    });
  }
  CloseEditVideoReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      videoReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditNotesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      notesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  OpenEditVideoReport = (item, e) => {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item['cfa3_video_reports.id'],
      // reportEditId: item.id,
      videoReport: item['cfa3_video_reports.comment'],
      type: 'videoReport',
    });
  };

  OpenEditNotesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      notesReport: item.comment,
      type: 'notesReport',
    });
  }

  getNotesSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };

    await FD.callAPI(App_data.backend_api + '/cfa3_notes/getFavNotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ savednotes: resp.cfa_notes });
        } else {
        }
      },
    );
  };

  // function for get  notes report
  getNotesFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_notes/getFlashcardsnotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ notesFlashReport: resp.flash_report });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  Video falshCard
  getVideoFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/getFlashcardsVideobyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ videoFlashReport: resp.flash_report });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  video report
  getVideoReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/getReportsVideobyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ reportsvideo: resp.video });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  /*
   * get saved all video
   */
  getVideosSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/getFavVideosbyuserid', data).then(
      async resp => {
        if (resp.success) {
          // console.log('Saved Video -------> ', resp);
          this.setState({ savedvideo: resp.cfa_videos });
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  notes report
  getNotesReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_notes/getReportsNotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ reportnotes: resp.notes });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // notes form submit function
  async handleNotesReportSubmit(event) {
    event.preventDefault();
    if (this.state.notesReport === '' && this.state.notesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, notesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      notesReport: notesReport,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_notes/UpdateReportsNotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            notesReport: '',
          });
          await this.getNotesReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  // video form submit function
  async handleVideoReportSubmit(event) {
    event.preventDefault();
    if (this.state.videoReport === '' && this.state.videoReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, videoReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      videoReport: videoReport,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3_videos/UpdateReportsVideobyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            videoReport: '',
          });
          await this.getVideoReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  _deleteNotesFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Notesflashcard');
  };

  _deleteVideoFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Videoflashcard');
  };

  _deleteSaveNotes = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savednotes');
  };

  _deleteSaveVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savedvideos');
  };

  _deleteReportsNotes = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsnotes');
  };

  _deleteReportsVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsvideos');
  };
  /*
   * function for go to specific notes main page
   */
  _beginNotes = async (reading, e) => {
    var reading_id = '';
    var chapter_id = '';
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.question_id,
    };
    let offset = 0;
    await FD.callAPI(App_data.backend_api + '/cfa3_notes/getNotesByID', data).then(resp => {
      if (resp.success) {
        // ---------------------------------------
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapter_id: resp.notes[0].chapter_id,
          reading_id: resp.notes[0].reading_id,
          offset: this.state.offset,
          // limit: this.state.limit,
        };
        chapter_id = resp.notes[0].chapter_id;
        FD.callAPI(App_data.backend_api + '/cfa3_notes/getNotes_allcr', data).then(async resp => {
          if (resp.success) {
            for (var i = 0; i < resp.questions.length; i++) {
              if (resp.questions[i].id === reading.question_id) {
                offset = i;
                // reading_id = resp.notes[0].reading_id;
                this.context.router.push({
                  pathname: `${AppRoutes.CFA3_BEGIN_NOTES}`
                    .replace(':notesid', chapter_id)
                    .replace(':readingid', resp.questions[i].reading_id)
                    .replace(':id', reading.question_id)
                    .replace(':offset', offset),
                });
                break;
              }
            }
          }
        });
        // ---------------------------------------
      }
    });
  };

  redirectToList = async (reading, e) => {
    const { chapter_id, video_id, case_id, pathway_id } = reading;
    const videoId = video_id ? video_id : reading['cfa3_video_reports.video_id'];

    this.context.router.push({
      pathname: AppRoutes.VIDEOS_LIST.replace(':id', videoId).replace(':chapterId', chapter_id),
      query: { ...(case_id && { caseId: case_id }), ...(pathway_id && { pathwayId: pathway_id }) },
    });
  };
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          alt=''
          width='18'
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id}></i>*/}
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default Cfa3Dashboard;


// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3Dashboard/Cfa3Dashboard.js